<div class="card">
  <app-header
    titulo="Recursos"
    descricao="Gerenciamento de todos os recursos de todos os processos de integração.">
  </app-header>

  <p-table
    [value]="recursos"
    [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped"
    [paginator]="true"
    [rows]="20"
    [globalFilterFields]="['nome', 'descricao', 'processoNome']"
    (onRowReorder)="onRowReorder($event)"
    [reorderableColumns]="true">

    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center">
        <p-button
          label="Atualizar"
          icon="pi pi-refresh"
          (onClick)="carregarRecursos()"
          [loading]="loading">
        </p-button>
        <!-- Filtros -->
        <div class="flex gap-2">
            <!-- Filtro por processo e tipo -->
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th> <!-- Drag handle -->
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="tipoRecurso">Tipo <p-sortIcon field="tipoRecurso"></p-sortIcon></th>
        <th pSortableColumn="processoNome">Processo <p-sortIcon field="processoNome"></p-sortIcon></th>
        <th pSortableColumn="ordemExecucao">Ordem <p-sortIcon field="ordemExecucao"></p-sortIcon></th>
        <th pSortableColumn="ativo">Status <p-sortIcon field="ativo"></p-sortIcon></th>
        <th style="width: 8rem">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-recurso let-rowIndex="rowIndex">
      <tr [pReorderableRow]="rowIndex">
        <td>
          <span class="pi pi-bars" pReorderableRowHandle></span>
        </td>
        <td><strong>{{ recurso.nome }}</strong></td>
        <td>
          <i [class]="getIconeRecurso(recurso.tipoRecurso) + ' mr-2'"></i>
          {{ recurso.tipoRecurso | titlecase }}
        </td>
        <td>{{ recurso.processoNome }}</td>
        <td>{{ recurso.ordemExecucao }}</td>
        <td>
          <p-tag [value]="recurso.ativo ? 'Ativo' : 'Inativo'" [severity]="recurso.ativo ? 'success' : 'danger'"></p-tag>
        </td>
        <td>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deletarRecurso(recurso)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center p-4">Nenhum recurso encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
